import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@tfecom-thermofisher/react-komodo-design';

import { Spacer, Message, Icon } from 'src/core/components';
import DetailRow from 'src/components/DetailRow';

import { QUALITY_TESTING_FIELD } from 'src/constants/forms';
import messages from './messages';
import './UploadedTemplateDetails.style.scss';

const getShippingMessage = (shippingDays) => {
  if (shippingDays === -1 || shippingDays === null) {
    return messages.inquireShippingDays;
  }

  return {
    ...messages.businessDays,
    values: { days: shippingDays }
  };
};

const UploadedTemplateDetails = ({ details, formData }) => {
  const { shippingDays, ...mainDetails } = details;

  return (
    <>
      <Spacer top={17} />
      <div className="dna-template-details">
        <div>
          {Object.keys(mainDetails).map((key) => (
            <DetailRow label={messages[key]} value={mainDetails[key]} key={`detail-row-${key}`} />
          ))}
        </div>
        <div className="dna-template-details__shipping">
          {formData?.[QUALITY_TESTING_FIELD]?.value !== 100 ? (
            <DetailRow
              label={messages.expectedShipment}
              value={<Message message={getShippingMessage(shippingDays)} />}
              key="detail-row-shippingDays"
            />
          ) : (
            <DetailRow
              value={<Message message={messages.qualityTestingFull} />}
              key="detail-row-shippingDays"
              notificationMsg
            />
          )}
          <Spacer right={9} />
          <Tooltip
            tooltipContent={(
              <div className="dna-template-details__tooltip">
                <Message message={messages.tooltip} />
              </div>
            )}
            placement="bottom-start"
            trigger="mouseenter"
          >
            <div className="dna-template-details__tooltip-icon">
              <Icon name="info-mono" color="blue" />
            </div>
          </Tooltip>
        </div>
      </div>
    </>
  );
};

UploadedTemplateDetails.propTypes = {
  details: PropTypes.object,
  formData: PropTypes.object
};

export default UploadedTemplateDetails;
